/* eslint no-undef: 'off' */
import $ from "jquery";
import Dropzone from "dropzone";

const dropzone = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-ChangeTab",
      inputUpload: ".js-DropzoneUpload",
      placeholder: ".js-PlaceholderUpload",
      counter: ".js-CountPhoto",
      maxNumber: ".js-maxPhoto",
      url_image: "#url_image",
    };

    if ($(el.placeholder).length === 0) return;

    const originalURL = window.location.href;
    // Create an anchor element to parse the URL
    const parser = document.createElement("a");
    parser.href = originalURL;
    // Get the base URL
    // const baseURL = parser.protocol + '//' + parser.host + '/';

    let fileCount = 0;
    let max = 10;
    $(el.maxNumber).text(max);
    new Dropzone(el.inputUpload, {
      url: themeObj.ajaxUrl,
      paramName: "file",
      acceptedFiles: "image/*",
      addRemoveLinks: true,
      dictRemoveFile: `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
          <path d="M6 2L2 6M2 2L6 6" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
      init: function () {
        this.on("addedfile", function (file) {
          fileCount++;
          $(el.counter).text(fileCount);

          const ajax = themeObj.ajax_handle_upload_dropzone;

          file.action = ajax.action;
          file.nonce = ajax.nonce;
        });

        this.on("removedfile", function (file) {
          fileCount--;
          $(el.counter).text(fileCount);

          const ajaxRemoveFile = themeObj.ajax_remove_file;
          const data = {
            action: ajaxRemoveFile.action,
            nonce: ajaxRemoveFile.nonce,
            file_name: file.name,
          };
          $.ajax({
            type: "POST",
            url: themeObj.ajaxUrl,
            data: data,
            success: function (response) {
              const url_image = $(el.url_image).val();
              const currentData = JSON.parse(url_image);
              const fileUrl = response.data.file_url;
              const index = currentData.indexOf(fileUrl);
              if (index !== -1) {
                currentData.splice(index, 1);
                $(el.url_image).val(JSON.stringify(currentData));
              }
            },
            error: function (error) {
              console.error(error);
            },
          });
        });

        this.on("sending", function (file, xhr, formData) {
          formData.append("action", file.action);
          formData.append("nonce", file.nonce);
        });

        this.on("success", function (file, response) {
          const file_url = response.data.file_url;
          if ($(el.url_image).val().indexOf(file_url) === -1) {
            const currentData =
              $(el.url_image).val() !== ""
                ? JSON.parse($(el.url_image).val())
                : [];
            currentData.push(file_url);
            $(el.url_image).val(JSON.stringify(currentData));
          }
        });
      },
    });
  };

  init();
};

try {
  dropzone();
} catch (error) {
  console.error("dropzone: ", error);
}
